import request from '~/utils/request';
import { IAPIResponse } from '~/utils/types';
import { IBvaResult, ZBvaResultResponse, ZUpdatedBvaResultResponse } from '~/services/parallel/bva.types';

export const getBvaResult = async (organizationUuid: string): Promise<IBvaResult | null> => {
  const response = (await request({
    url: `/bva`,
    method: 'GET',
    headers: { 'Organization-Uuid': organizationUuid },
  })) as IAPIResponse;

  return ZBvaResultResponse.parse(response.data.data).bvaResult;
};

export const completeReview = async ({
  organizationUuid,
  headcountReviewsToComplete,
  expenseReviewsToComplete,
  modelReviewsToComplete,
}: {
  organizationUuid: string;
  headcountReviewsToComplete?: string[];
  expenseReviewsToComplete?: string[];
  modelReviewsToComplete?: string[];
}): Promise<IBvaResult | null> => {
  const response = (await request({
    url: `/bva/complete-review`,
    method: 'PATCH',
    body: {
      headcountReviewsToComplete,
      expenseReviewsToComplete,
      modelReviewsToComplete,
    },
    headers: { 'Organization-Uuid': organizationUuid },
  })) as IAPIResponse;

  return ZUpdatedBvaResultResponse.parse(response.data.data).updatedBvaResult;
};
